import { render, staticRenderFns } from "./aboutFestival.vue?vue&type=template&id=8ed8ef2a&scoped=true&"
import script from "./aboutFestival.vue?vue&type=script&lang=js&"
export * from "./aboutFestival.vue?vue&type=script&lang=js&"
import style0 from "./aboutFestival.vue?vue&type=style&index=0&id=8ed8ef2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed8ef2a",
  null
  
)

export default component.exports